import React from "react";
import Emissions from "components/app/report/environment/emissions/Emissions";

type ScreenEmissionProps = React.PropsWithChildren<{}>;

function ScreenEmissions(props: ScreenEmissionProps) {
	return <Emissions />;
}

export default ScreenEmissions;
